// extracted by mini-css-extract-plugin
module.exports = {"stop-wrapper":"stopsign_stop-wrapper__2_pbo"};